<template>
  <div class="orderDetail">
    <el-dialog :close-on-click-modal="false" title="评价详情" :visible.sync="showDialog" @close="$emit('update:showDetails', false)"
               :showDetails="showDetails" style="height: 400px" width="500px">
      <el-row style="height: 300px">
        <el-col :span="4">
          <div class="grid-content bg-purple-dark"><span>&nbsp;</span></div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple-dark">评价内容：</div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple-dark">{{ rowInfo.comment_content}}</div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "detailed",
    data() {
      return {
        showDialog: this.showDetails,
      }
    },
    props: {
      rowInfo: {
        type: Object
      },
      showDetails: {
        type: Boolean,
        default:false
      }
    },
    watch: {
      showDetails() {
        this.showDialog = this.showDetails
      }
    }
  }
</script>
